import { Accordion, AccordionDetails, AccordionSummary, Button, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper, Typography, useTheme } from "@mui/material";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from "react";
import MyTable from "../../../components/MyTable";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { approveCoupon, searchCouponsToMyChargeEmployees, setCouponsToApproveERPReponse } from "../../../store/slices/userRequests";
import { S10CouponsToMyChargePartial } from "../../../interfaces/s10Employees.interface";
import { CompanyEmployees } from "../../../interfaces/auth.interface";
import { setAproveCouponCloud, setRejectCouponCloud } from "../../../api/s10DocumentsApi";
import MySnackbar from "../../../components/MySnackbar";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { DocumentsComponent } from "../../../components/DocumentsComponent";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { formatDateToTimestamp } from "../../../utils/date";
import { COUPONS_TO_MY_CHARGE_HISTORY_THREE } from "../../../constants/signalRequestConsts";
import { getInMyChangeOfficesByEmployeeCode } from "../../../api/s10OrganizationApi";


const requestId = COUPONS_TO_MY_CHARGE_HISTORY_THREE;

const Approvals = () => {

    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {couponToApproveERPResponse} = useSelector((state: RootState) => state.userRequests)[requestId];
    const {employeesLoading, employees} = useSelector((state: RootState) => state.userRequests)[requestId];
    const [accordionExpanded, setAccordionExpanded] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [approveCouponData, setApproveCouponData] = useState<any>(null)
    const [rejectCouponData, setRejectCouponData] = useState<any>(null)
    const [rejectCoupon, setRejectCoupon] = useState<any>()
    const [groupId, setGroupId] = useState<string | null>(null);
    const [companiesData, setCompaniesData] = useState<{CompanyCode: string, Name: string}[]>([])
    
    const [errorMsg, setErrorMsg] = useState<string>("");

    useEffect(() => {
        if (isLoading || employeesLoading) {
            return;
        }
        getInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId]);

    
    useEffect(() => {
        // const couponToApproveERPResponse = {Success: 1, Response: 'Papeleta N° 00003685 se ha creado satisfactoriamente.', Code: 'F97A6A3B-3B34-4D6E-BFE8-9C37572CAE9F;00003685'}
        if (couponToApproveERPResponse?.Success !== 1) {
            setApproveCouponData(null);
            setRejectCouponData(null)
            return;
        }
        setAproveCouponCloud()
            .then(s => {
                console.log(s);
                setApproveCouponData(null);
                setRejectCouponData(null)
                if(s.Type === 0) dispatch(searchCouponsToMyChargeEmployees(requestId));
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [couponToApproveERPResponse]);

    const getInitialData = async () => {
        if (!companyselected || !connectionId || isLoading || employeesLoading) {
            return;
        }
        setIsLoading(true)
        const {data} = await getInMyChangeOfficesByEmployeeCode();
        if (!data.length) {
            setErrorMsg("No fue posible obtener el listado de compañias.");
            return;
        }
        setCompaniesData(data);
        dispatch(searchCouponsToMyChargeEmployees(requestId));
    }

    const handleAproveCoupon = async (couponRequestData: S10CouponsToMyChargePartial & CompanyEmployees) => {
        dispatch(approveCoupon(couponRequestData, requestId));
    }

    const handleRejectCoupon = async (couponRequestData: S10CouponsToMyChargePartial & CompanyEmployees) => {
        console.log(couponRequestData);
        const result = await setRejectCouponCloud(couponRequestData);
        console.log(result)
        setRejectCoupon({
            Message: result?.Message || "Ocurrió un error.",
            Type: result?.Type,
        })
    }

    const tableHeadRows = [
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
        },{
            label: "Cupón",
            rowKeyName: "CouponName",
        },{
            label: "Fecha Solicitud",
            rowKeyName: "RequestDate",
        },{
            label: "Fec. inicio",
            rowKeyName: "RangeStart",
        },{
            label: "Fec. fin",
            rowKeyName: "RangeEnd",
        },{
            label: "Cantidad",
            rowKeyName: "RangeCountString",
        }, {
            label: "",
            rowKeyName: "actions",
            customValue: (headRow: any, row: any) => {
                if (!row.HasAttachment) {
                    return <></>
                }
                return (                                  
                    <Grid
                        container
                        padding={0}
                        spacing={0}
                        // marginTop="1rem"
                        direction="row"
                    >
                        <IconButton
                            aria-label="ver adjuntos"
                            onClick={() =>{
                                setGroupId(row.FilesGroup)
                            }}
                            style={{
                                // minWidth: "2rem",
                                // minHeight: "2rem",
                                padding: "0 !impoertant",

                                lineHeight: "1.25rem", 
                            }}
                        >
                            <AttachFileIcon color="primary" />
                        </IconButton>
                    </Grid>
                )
            },
        }, {
            label: "",
            rowKeyName: "actions",
            customValue: (headRow: any, row: any) => {
                return (                                  
                    <Grid
                        container
                        padding={0}
                        spacing={0}
                        marginTop="1rem"
                        direction="row"
                    >
                        <Grid 
                            container 
                            item
                            xs={11}
                            direction="row"
                            justifyContent="end"
                            sx={{
                                alignItems: "center",
                            }}
                        >
                            <Grid item>
                                <Button
                                    color="success"
                                    variant="outlined"
                                    style={{
                                        padding: ".1rem",
                                        lineHeight: "normal",
                                    }}
                                    disabled={!row.ApprovalCode}
                                    onClick={() =>setApproveCouponData(row)}
                                >
                                    Aprobar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    color="error"
                                    variant="outlined"
                                    style={{
                                        padding: ".1rem",
                                        lineHeight: "normal",
                                        marginLeft: ".5rem"
                                    }}
                                    disabled={!row.ApprovalCode}
                                    onClick={() =>setRejectCouponData(row)}
                                >
                                    Rechazar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            },
        }
    ]

    const handleExpansion = (i: number, value: any) => {
        setAccordionExpanded(i === accordionExpanded ? -1 : i)
    }

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper 
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem",
                height: "100%",
            }}
        >
        {companiesData.map((value, i) => ( 
            <Accordion
                key={i}
                expanded={accordionExpanded === i}
                onChange={(value) => handleExpansion(i, value)}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    style={{
                        backgroundColor: theme.s10palette.S10Blueblue50,
                        height: "3rem",
                        minHeight: "3rem",
                    }}
                >
                    <Typography variant="h6" fontSize="1rem">Empresa: {value.Name}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {accordionExpanded === i && 
                        
                        <MyTable
                            key="tab-0"
                            hiddenSearchInput={true}
                            tableHeadRows={tableHeadRows}
                            tableRows={employees.filter(e => e.RUCEmpresa === value.CompanyCode)}
                            loading={false}
                            cardComponent={{
                                imageData: {
                                    descriptionRowName: "Descripcion",
                                },
                                cardContent: (row) => {
                                    return (
                                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                                            <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                                                {row.CouponName} 
                                            </Typography>
                                            <Typography variant="body2" style={{lineHeight: "1.5em"}}>
                                                Desde {row.RangeStart}
                                            </Typography>
                                            <Typography variant="body2" style={{lineHeight: "1.5em"}}>
                                                hasta {row.RangeEnd}
                                            </Typography>
                                            <Typography variant="body2">
                                                Solicitado el {`${formatDateToTimestamp(row.RequestDate)}`}
                                            </Typography>                                            
                                            <Grid
                                                container
                                                padding={0}
                                                spacing={0}
                                                marginTop="1rem"
                                                direction="row"
                                            >
                                                {row.HasAttachment && <Grid item xs={1}>
                                                    <IconButton
                                                        aria-label="ver adjuntos"
                                                        onClick={() =>{
                                                            setGroupId(row.FilesGroup)
                                                        }}
                                                        style={{
                                                            minWidth: "2rem",
                                                            minHeight: "2rem",
                                                            padding: ".25rem",

                                                            lineHeight: "1.25rem", 
                                                        }}
                                                    >
                                                        <AttachFileIcon color="primary" />
                                                    </IconButton>
                                                </Grid>}
                                                

                                                <Grid 
                                                    container 
                                                    item
                                                    xs={11}
                                                    direction="row"
                                                    justifyContent="end"
                                                    sx={{
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Grid item>
                                                        <Button
                                                            color="success"
                                                            variant="outlined"
                                                            style={{
                                                                padding: ".1rem",
                                                                lineHeight: "normal",
                                                            }}
                                                            disabled={!row.ApprovalCode}
                                                            onClick={() =>setApproveCouponData(row)}
                                                        >
                                                            Aprobar
                                                        </Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button
                                                            color="error"
                                                            variant="outlined"
                                                            style={{
                                                                padding: ".1rem",
                                                                lineHeight: "normal",
                                                                marginLeft: ".5rem"
                                                            }}
                                                            disabled={!row.ApprovalCode}
                                                            onClick={() =>setRejectCouponData(row)}
                                                        >
                                                            Rechazar
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    );
                                }
                            }}
                            tableOptionsBar={{
                                useDrawer: true,
                            }}
                        />
                    }
                </AccordionDetails>
            </Accordion>
        ))}                    
        </Paper>

        
        {groupId !== null && <Dialog
            key={groupId}
            maxWidth="md"
            
            open={groupId !== null}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
            PaperProps={{
                style: {
                width: '80%',
                // maxWidth: '600px',   // Máximo ancho del Dialog
                }
            }}
            fullWidth
        
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Documentos
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <DocumentsComponent groupId={groupId} allowToDeleteFiles={false} allowToAddFiles={false} />
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={12} textAlign={"right"}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setGroupId(null)}
                        >
                            Cerrar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
    
        {(approveCouponData || rejectCouponData) && <Dialog
            open={true}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", textAlign: "center", marginTop: "1.5rem"}} 
                variant="h5"
            >
                {approveCouponData ? "Aprobar" : "Rechazar"} cupón
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
            </DialogContent>
                <DialogTitle 
                    id="responsive-dialog-title" 
                    style={{padding: "0", textAlign: "center"}} 
                    variant="body1"
                >
                    ¿Seguro de {approveCouponData
                                ? "aprobar"
                                : "rechazar"
                            } el cupón?
                </DialogTitle>
            <DialogActions>
                <Grid container >
                    <Grid item xs={6}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => {
                                setApproveCouponData(null);
                                setRejectCouponData(null);
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button 
                            variant="contained"
                            color={approveCouponData
                                ? "primary"
                                : "error"
                            }
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={approveCouponData
                                ? () => handleAproveCoupon(approveCouponData)
                                : () => handleRejectCoupon(rejectCouponData)
                            }
                        >
                            {approveCouponData
                                ? "Aprobar"
                                : "Rechazar"
                            }
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}


        {couponToApproveERPResponse && <MySnackbar
            msg={couponToApproveERPResponse?.Response}
            severity={couponToApproveERPResponse.Success ? "success" : "error"}
            open={!!couponToApproveERPResponse}
            onClose={() => {
                dispatch(setCouponsToApproveERPReponse({data: null, requestId}))
            }}
        />}
        {rejectCoupon && <MySnackbar
            msg={rejectCoupon.Message}
            severity={rejectCoupon.Type === 0 ? "success" : "error"}
            open={!!rejectCoupon}
            onClose={() => {
                setRejectCoupon(undefined)
            }}
        />}
        {errorMsg && <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
        />}
    </Grid>)
}

export default Approvals;